import vuexStoreFactory from "@/_util/vuex-store-factory"
let factory = new vuexStoreFactory();

import config from "@/_store/modules/app-settings-config"

var appSettingsMixin = factory.generateMixin(config)

export default {

  data() {
    return {
      applicationSettings: null,
    };
  },
  watch: {
    applicationSettings(newVal) {
      if (newVal.hasOwnProperty("mainNavEnabled")) this.globalmainNavEnabled = newVal.mainNavEnabled;
    }
  },
  mixins: [appSettingsMixin],

}
